module.exports = __webpack_public_path__ + "media/mypage/images/fa/3-70d03407b5a8e709892a7cf1290e64d6.jpg";